import React, { useState, useEffect } from 'react';
import { Select, Input, Row, Col } from 'antd';
import { projectStacks } from '../../services/cs-lab-config';
import { getIdeProjectTypeMetaData } from '../utils/util-functions';

const { Option } = Select;

const LabQuestionFilter = ({ onChange }) => {
    const [selectedProjectTypes, setSelectedProjectTypes] = useState([]);
    // const [selectedTopics, setSelectedTopics] = useState([]);
    const [searchText, setSearchText] = useState('');

    const handleProjectTypeChange = (values) => {
        setSelectedProjectTypes(values);
    };


    const handleSearchTextChange = (e) => {
        setSearchText(e.target.value);
    };

    useEffect(() => {
        // You can perform any additional logic or fetch data based on selected filters here
        // Call the onChange prop with the selected filters
        onChange({
            projectTypes: selectedProjectTypes,
            // topics: selectedTopics,
            searchText: searchText,
        });
    }, [selectedProjectTypes, searchText, onChange]);

    return (
        <Row gutter={16} className='mb-4'>
            <Col span={8}>
                <Select
                    mode="multiple"
                    placeholder="Select Project Types"
                    style={{ width: '100%' }}
                    onChange={handleProjectTypeChange}
                    value={selectedProjectTypes}
                >
                    {Object.values(projectStacks)
                        .flatMap((items) =>
                        items
                            .map((item) => ({
                            ...item,
                            metaData: getIdeProjectTypeMetaData(item.projectStackName),
                            }))
                            .filter((item) => item.metaData.showLabQuestion)
                        )
                        .map((item) => (
                        <Option key={item.projectStackName} value={item.projectStackName}>
                            {item.metaData.projectStackDisplayName}
                        </Option>
                        ))}
                </Select>
            </Col>

            <Col span={8}>
                <Input
                    placeholder="Search Text"
                    style={{ width: '100%' }}
                    onChange={handleSearchTextChange}
                    value={searchText}
                />
            </Col>
            <Col span={8}>
                {/* <Select
                    mode="multiple"
                    placeholder="Select Topics"
                    style={{ width: '100%' }}
                    onChange={handleTopicChange}
                    value={selectedTopics}
                >
                   
                </Select> */}
            </Col>
        </Row>
    );
};

export default LabQuestionFilter;
